var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.opened
    ? _c("div", { staticClass: "modal-mask" }, [
        _c("div", { staticClass: "modal-wrapper" }, [
          _c(
            "div",
            { staticClass: "modal-dialog modal-lg modal-dialog-scrollable" },
            [
              _c("div", { staticClass: "modal-content" }, [
                _c("div", { staticClass: "modal-header" }, [
                  _c("h5", { staticClass: "modal-title" }, [
                    _vm._v("Set up your meeting​"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "close",
                      attrs: { type: "button" },
                      on: { click: _vm.close },
                    },
                    [_vm._v("×")]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-body" }, [
                  _vm._m(0),
                  _c("br"),
                  _vm._v(" "),
                  _c("table", { staticClass: "table" }, [
                    _c("tbody", [
                      _vm.surveyStarted
                        ? _c("tr", [
                            _vm._m(1),
                            _vm._v(" "),
                            _c("td", { staticClass: "align-middle" }, [
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "btn btn-outline-success btn-block text-nowrap",
                                  on: { click: _vm.closeSurvey },
                                },
                                [_vm._v("Close survey")]
                              ),
                            ]),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.surveyStarted
                        ? _c("tr", [
                            _vm._m(2),
                            _vm._v(" "),
                            _c("td", { staticClass: "align-middle" }, [
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "btn btn-outline-secondary btn-block text-nowrap",
                                  on: { click: _vm.openSurvey },
                                },
                                [_vm._v("Open survey")]
                              ),
                            ]),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.autoRevealEnabled
                        ? _c("tr", [
                            _vm._m(3),
                            _vm._v(" "),
                            _c("td", { staticClass: "align-middle" }, [
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "btn btn-outline-secondary btn-block text-nowrap",
                                  on: { click: _vm.toggleAutoReveal },
                                },
                                [_vm._v("Turn off")]
                              ),
                            ]),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.autoRevealEnabled
                        ? _c("tr", [
                            _vm._m(4),
                            _vm._v(" "),
                            _c("td", { staticClass: "align-middle" }, [
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "btn btn-outline-secondary btn-block text-nowrap",
                                  on: { click: _vm.toggleAutoReveal },
                                },
                                [_vm._v("Turn on")]
                              ),
                            ]),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.namesRevealed
                        ? _c("tr", [
                            _vm._m(5),
                            _vm._v(" "),
                            _c("td", { staticClass: "align-middle" }, [
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "btn btn-outline-secondary btn-block text-nowrap",
                                  on: { click: _vm.toggleNamesRevealed },
                                },
                                [_vm._v("Turn on")]
                              ),
                            ]),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.namesRevealed
                        ? _c("tr", [
                            _vm._m(6),
                            _vm._v(" "),
                            _c("td", { staticClass: "align-middle" }, [
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "btn btn-outline-secondary btn-block text-nowrap",
                                  on: { click: _vm.toggleNamesRevealed },
                                },
                                [_vm._v("Turn off")]
                              ),
                            ]),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("tr", [
                        _vm._m(7),
                        _vm._v(" "),
                        _c("td", { staticClass: "align-middle" }, [
                          _c(
                            "button",
                            {
                              staticClass:
                                "btn btn-outline-secondary btn-block text-nowrap",
                              on: { click: _vm.showAccessLinks },
                            },
                            [_vm._v("Access links")]
                          ),
                        ]),
                      ]),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-footer" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      attrs: { type: "button" },
                      on: { click: _vm.startMeeting },
                    },
                    [_vm._v("Start the meeting")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-outline-secondary",
                      attrs: { type: "button" },
                      on: { click: _vm.close },
                    },
                    [_vm._v("Cancel")]
                  ),
                ]),
              ]),
            ]
          ),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("p", { staticClass: "lead" }, [
      _vm._v(
        "\n                        Before you start your real-time meeting, let’s make sure everything is ready.\n                        "
      ),
      _c("strong", [
        _vm._v("You can change any of these settings during the meeting."),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("td", [
      _c("h5", [_vm._v("Survey is open")]),
      _vm._v(" "),
      _c("p", [
        _vm._v("Your team can change their answers to "),
        _c("strong", [_vm._v("ANY question")]),
        _vm._v(" during the meeting. "),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("td", [
      _c("h5", [_vm._v("Survey is closed")]),
      _vm._v(" "),
      _c("p", [
        _vm._v("Your team will only be able to change their answers for the "),
        _c("strong", [_vm._v("question you’re on.")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("td", [
      _c("h5", [_vm._v("Auto reveal is ON")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "When you move from question to question, your meeting participants WILL be able to see each others’ votes.​"
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("td", [
      _c("h5", [_vm._v("Auto reveal is OFF")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "When you move to the next question, we will automatically hide everyone’s votes. This can help reduce “follow my leader” bias and “group think.”"
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("td", [
      _c("h5", [_vm._v("Anonymous mode is OFF")]),
      _vm._v(" "),
      _c("p", [_vm._v("When sharing votes, names WILL be displayed.​")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("td", [
      _c("h5", [_vm._v("Anonymous mode is ON")]),
      _vm._v(" "),
      _c("p", [_vm._v("When sharing votes, names WILL NOT be displayed.​")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("td", [
      _c("h5", [_vm._v("Access links")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "These links will let your participants join the meeting with just one click. Why not (re)send them now?​"
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }